/** @jsx $jsx */
import { $jsx } from 'framework7';
// import params from "../js/params.js";
// const API_URL = params.apiUrl;
// const BACKEND_URL = params.backendUrl;

var API_URL = "https://api.enay-digital.ru";
var BACKEND_URL = "https://enay-digital.ru";
var upd = 1;
function framework7Component(props, _ref) {
  var $on = _ref.$on,
    $ = _ref.$,
    $f7 = _ref.$f7,
    $onMounted = _ref.$onMounted,
    $update = _ref.$update;
  var categories = [];
  var fileUrl = BACKEND_URL;
  var is_loading = true;
  var swiper = null;
  var popup = null;
  $on("pageInit", function () {
    if (upd === 1 && !localStorage.getItem("hide_hello")) {
      // popup = $f7.popup.create({
      //   el: ".popup-hello",
      //   on: {
      //     open: function (popup) {
      //       swiper = $f7.swiper.create(".swiper-hello", {
      //         pagination: {
      //           el: ".swiper-pagination",
      //         },
      //       });
      //     },
      //   },
      // });
      // popup.open();
    }
    upd++;
    $f7.request.json("".concat(API_URL, "/v1/categories"), {
      expand: "parent,categories,posts",
      "filter[parent_id]": "null"
    }).then(function (response) {
      categories = response.data.items;
      $update();
    }).finally(function () {
      is_loading = false;
      $update();
    });
  });
  $(document).on("click", ".swiper-hello-btn", function () {
    localStorage.setItem("hide_hello", 1);
    if (swiper) {
      if (swiper.activeIndex === 2) {
        popup.close();
      }
      swiper.slideNext();
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="home">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="title title-image">
          <svg
            width="35"
            height="35"
            viewBox="0 0 35 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="35" height="35" rx="17.5" fill="#0F23E1" />
            <path
              d="M23.4598 15.7481C23.336 15.533 23.1093 15.4009 22.8638 15.4009H17.4256L18.0385 9.19715C18.0708 8.86973 17.8723 8.56411 17.5629 8.46407C17.2535 8.36467 16.9157 8.49604 16.755 8.78195L11.2441 18.5403C11.1224 18.7561 11.123 19.0208 11.2462 19.2359C11.3699 19.451 11.5966 19.583 11.8422 19.583H17.2803L16.6675 25.7868C16.6352 26.1142 16.8336 26.4199 17.1431 26.5199C17.4529 26.6203 17.7897 26.488 17.951 26.202L23.4618 16.4437C23.5836 16.228 23.5829 15.9632 23.4598 15.7481Z"
              fill="url(#paint0_linear_209_930)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_209_930"
                x1="22.6735"
                y1="11.7036"
                x2="1.68938"
                y2="11.1877"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0.2" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div class="right">
          <a href="#" class="link link-telegram">
            <i class="icn icn-telegram"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="page-content">
      <div class="block block-grid">
        ${categories.map((item) => $h`
        <a href="/category/${item.id}/" class="index-card">
          <div class="index-card-title">${item.title}</div>
          <div class="index-card-text">${item.short_description}</div>
          <img
            class="index-card-image"
            src="${fileUrl}/index.php?r=site/file&id=${item.thumbnail_id}"
            alt=""
          />
        </a>
        `)}
      </div>
    </div>

    <div class="popup popup-hello">
      <div class="block">
        <div class="swiper-container swiper-hello">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="swiper-hello-img1"></div>

              <h2 class="text-align-center">Привет!</h2>
              <p>
                Рады видеть вас в нашем приложении. Именно благодаря ему вы
                сможете стать юридически грамотным человеком.
              </p>
              <p>
                Для этого вам даже не понадобится тратить кучу денег и времени
                на поход к юристу. Вы сможете сами решать свои проблемы.
              </p>
            </div>

            <div class="swiper-slide">
              <h2>
                С помощью данного приложения вы найдете ответы на вопросы:
              </h2>
              <ul>
                <li>Как вернуть товар, заказанный в интернет-магазине?</li>
                <li>Какие действия нужно совершить при эвакуации авто?</li>
                <li>
                  Как законно избавиться от долга в размере более 500 000
                  рублей?
                </li>
              </ul>
              <p>Мы поможем вам найти выход из любой ситуации.</p>
            </div>

            <div class="swiper-slide">
              <div class="swiper-hello-img2"></div>
              <h2 class="text-align-center">Добро пожаловать в Enay!</h2>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="swiper-hello-footer">
        <div class="block">
          <button type="button" class="btn swiper-hello-btn">Далее</button>
        </div>
      </div>
    </div>
  </div>
`
    }
    ;
}
framework7Component.id = 'b8dbe1788b';
export default framework7Component;